import { PromotedServiceAssignment, PromotedServiceAssignmentOptions } from '@mews-commander/data-access';
import { FormFields, FormValues, OptionsNames } from '../schema';

export const defaultOptionSelection = {
    [OptionsNames.InBookingEnging]: true,
    [OptionsNames.DuringOnlineCheckin]: true,
};

export const getOptionsFromFormValues = (options: OptionsNames[]): PromotedServiceAssignmentOptions =>
    Object.values(OptionsNames).reduce(
        (acc, option) => ({ ...acc, [option]: options.includes(option) }),
        defaultOptionSelection
    );

export const getIsExistingService = ({
    existingServices,
    newService,
    editedPromotionId,
}: {
    existingServices: PromotedServiceAssignment[];
    newService: FormValues;
    editedPromotionId?: string;
}) => {
    const existingService = existingServices.find(
        (service) =>
            service.promotedRateId === newService[FormFields.PromotedRateId] &&
            service.promotedResourceCategoryId === newService[FormFields.PromotedResourceCategoryId] &&
            service.promotedServiceId === newService[FormFields.PromotedServiceId]
    );
    const isExistingServiceBeingEdited = existingService?.id === editedPromotionId;
    return !!existingService && !isExistingServiceBeingEdited;
};
